import * as React from "react";
import Svg, { Circle, Path } from 'react-native-svg';

export const LongerRouteAtBothEnds = (props) => {
  return (
    <Svg
      width={14}
      height={178}
      viewBox="0 0 14 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={7} cy={5} r={5} fill="#D9D9D9" />
      <Circle cx={7} cy={61} r={7} fill="#33D18F" />
      <Circle cx={7} cy={118} r={7} fill="#33D18F" />
      <Circle cx={7} cy={173} r={5} fill="#D9D9D9" />
      <Path stroke="#33D18F" strokeWidth={2} d="M7 65L7 114" />
      <Path
        stroke="#D9D9D9"
        strokeWidth={2}
        strokeDasharray="4 4"
        d="M7 10L7 54"
      />
      <Path
        stroke="#D9D9D9"
        strokeWidth={2}
        strokeDasharray="4 4"
        d="M7 125L7 168"
      />
      <Path
        d="M4 61l2 2.5 4-4M4 117.5l2 2.5 4-4"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export const LongerRouteAtSource = (props) => {
  return (
    <Svg
      width={14}
      height={125}
      viewBox="0 0 14 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={7} cy={5} r={5} fill="#D9D9D9" />
      <Circle cx={7} cy={61} r={7} fill="#33D18F" />
      <Circle cx={7} cy={118} r={7} fill="#33D18F" />
      <Path stroke="#33D18F" strokeWidth={2} d="M7 65L7 114" />
      <Path
        stroke="#D9D9D9"
        strokeWidth={2}
        strokeDasharray="4 4"
        d="M7 10L7 54"
      />
      <Path
        d="M4 61l2 2.5 4-4M4 117.5l2 2.5 4-4"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export const LongerRouteAtDestination = (props) => {
  return (
    <Svg
      width={14}
      height={124}
      viewBox="0 0 14 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={7} cy={7} r={7} fill="#33D18F" />
      <Circle cx={7} cy={64} r={7} fill="#33D18F" />
      <Circle cx={7} cy={119} r={5} fill="#D9D9D9" />
      <Path stroke="#33D18F" strokeWidth={2} d="M7 11L7 60" />
      <Path
        stroke="#D9D9D9"
        strokeWidth={2}
        strokeDasharray="4 4"
        d="M7 71L7 114"
      />
      <Path
        d="M4 7l2 2.5 4-4M4 63.5L6 66l4-4"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

export const CrossButton = (props) => {
  return (
    <Svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M1 1l11 11m0-11L1 12"
        stroke="#9B9B9B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}